module.exports = __webpack_public_path__ + "img/product-information.68db7b13.jpg";